import React from 'react';
import { Button } from "@/components/ui/button";
import { useIsMobile } from '@/hooks/use-mobile';
import { getImageUrl } from '@/lib/image-url';
import { useSiteImages } from '@/hooks/useSiteImages';

const HeroSection = () => {
  const isMobile = useIsMobile();
  const { images: desktopImages } = useSiteImages('hero-desktop');
  const { images: mobileImages } = useSiteImages('hero-mobile');

  const desktopImage = desktopImages[0]?.url
    ?? getImageUrl("exterieur/exterieur-maison-ty-gwennili.webp");
  const mobileImage = mobileImages[0]?.url
    ?? getImageUrl("sejour/maison-ty_gwennili-mobile.webp");

  const heroImage = isMobile ? mobileImage : desktopImage;
  
  return (
    <div className="relative h-[60vh] md:h-[85vh]">
      <img
        src={heroImage}
        alt="Ty Gwennili - Maison de vacances en Bretagne"
        className="absolute inset-0 w-full h-full object-cover"
        fetchPriority="high"
        decoding="async"
        loading="eager"
      />
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      <div className="relative container-custom h-full flex flex-col justify-center text-white pt-8 md:pt-0">
        <h1 className="text-4xl md:text-5xl font-amaranth mb-4 text-gray-50 font-light lg:text-7xl">Ty Gwennili</h1>
        <p className="text-xl md:text-2xl mb-6 max-w-2xl">
          Belle maison de vacances en Bretagne, 
          à quelques pas des plus belles plages du Finistère
        </p>
        <div>
          <Button className="hero-button" size="lg">
            <a href="#tarifs" className="flex items-center gap-2">
              <span>Réserver maintenant</span>
              <div className="arrow-wrapper">
                <div className="arrow bg-slate-900"></div>
              </div>
            </a>
          </Button>
        </div>
        
        <img 
          src={getImageUrl("Meuble-de-tourisme-2024-4-etoiles.webp")}
          alt="Meublé de tourisme 4 étoiles"
          className="absolute bottom-4 right-4 w-20 h-20 md:w-24 md:h-24 object-contain rounded-lg"
          loading="lazy"
          decoding="async"
        />
      </div>
    </div>
  );
};
export default HeroSection;
